import { render, staticRenderFns } from "./bookSearch.vue?vue&type=template&id=32b76690&scoped=true&"
import script from "./bookSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./bookSearch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./bookSearch.vue?vue&type=style&index=0&id=32b76690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b76690",
  null
  
)

export default component.exports